import script from "./TradeNetworkWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TradeNetworkWidget.vue?vue&type=script&setup=true&lang=js"

import "./TradeNetworkWidget.vue?vue&type=style&index=0&id=3e8668dc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e8668dc"]])

export default __exports__